import React from "react";
import PropTypes from "prop-types";

const FilterBarsIcon = ({
  width,
  height,
  className,
  color,
  fill,
  ...props
}) => {
  const pathFill = fill && fill !== "none" ? fill : color || "currentColor";

  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6.66667 12.2829C6.66667 12.6677 6.97854 12.9795 7.36327 12.9795H8.63673C9.02146 12.9795 9.33333 12.6677 9.33333 12.2829C9.33333 11.8982 9.02146 11.5863 8.63673 11.5863H7.36327C6.97855 11.5863 6.66667 11.8982 6.66667 12.2829ZM2.6966 4.62036C2.31188 4.62036 2 4.93224 2 5.31696C2 5.70168 2.31188 6.01356 2.6966 6.01356H13.3034C13.6881 6.01356 14 5.70168 14 5.31696C14 4.93224 13.6881 4.62036 13.3034 4.62036H2.6966ZM4 8.79995C4 9.18467 4.31188 9.49655 4.6966 9.49655H11.3034C11.6881 9.49655 12 9.18467 12 8.79995C12 8.41523 11.6881 8.10335 11.3034 8.10335H4.6966C4.31188 8.10335 4 8.41523 4 8.79995Z"
        fill={pathFill}
      />
    </svg>
  );
};

FilterBarsIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  fill: PropTypes.string,
};

FilterBarsIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  fill: undefined,
};

export default FilterBarsIcon;
